import './Overview.css'

function Overview({ data, totalThreads }) {
  const { totalFlags, flags, employeeUptakePercentage, outsideBusinessHoursPercentage } = data || {}
  
  const newFlags = flags?.filter(f => f.status === 'new').length || 0
  const activeEscalations = flags?.filter(f => f.status === 'new' || f.status === 'under_review').length || 0
  
  // Calculate Olivea's resolution rate
  const oliveResolutionRate = totalThreads > 0 
    ? Math.round(((totalThreads - totalFlags) / totalThreads) * 100)
    : 0

  if (totalFlags === 0) {
    return (
      <div className="empty-state">
        <div className="empty-state-icon">✅</div>
        <h3>No flags raised yet</h3>
        <p>When employees raise concerns through Olivea, they'll appear here.</p>
      </div>
    )
  }

  return (
    <div className="stats-grid">
      <div className="stat-card">
        <h3>Alerts</h3>
        <div className="value">{newFlags}</div>
      </div>
      <div className="stat-card">
        <h3>Active Escalations</h3>
        <div className="value">{activeEscalations}</div>
      </div>
      <div className="stat-card">
        <h3>Employee Uptake</h3>
        <div className="value">{employeeUptakePercentage !== null && employeeUptakePercentage !== undefined ? employeeUptakePercentage + '%' : 'N/A'}</div>
      </div>
      <div className="stat-card">
        <h3>Total Issues Raised</h3>
        <div className="value">{totalThreads || 0}</div>
      </div>
      <div className="stat-card">
        <h3>Olivea's Resolution Rate</h3>
        <div className="value">{oliveResolutionRate}%</div>
      </div>
      <div className="stat-card">
        <h3>Raised Outside Business Hours</h3>
        <div className="value">{outsideBusinessHoursPercentage || 0}%</div>
      </div>
    </div>
  )
}

export default Overview

